
<template>
  <div class="auditlist">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-dropdown @command="editdropdownitem">
        <el-button type="primary">
          {{ dropdownitem[1] }}
          <i class="el-icon-arrow-down el-icon--right"/>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item,index) in dropdownlist"
            :command="index"
            :key="item+index"
          >{{ item[1] }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-form-item>
        <el-input v-model="formInline.user" placeholder="请输入查询内容"/>
      </el-form-item>
      <el-form-item>
        <el-button v-if="calcPermission(permition, 3)" type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="auditlist.LsList" border style="width: 100%">
      <el-table-column label="公司" align="center" prop="CompanyName"/>
      <el-table-column :width="100" label="姓名" align="center" prop="UserInfo.UserName"/>
      <el-table-column label="工号" align="center" prop="UserInfo.WorkNum"/>
      <el-table-column label="电话号" align="center" prop="UserInfo.TelPhone"/>
      <el-table-column label="审核时间" align="center" prop="UserInfo.ValidTime"/>
      <el-table-column
        :width="100"
        :formatter="ValidStatusFilter"
        label="审核状态"
        align="center"
        prop="UserInfo.ValidStatus"
      />
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleSee(scope.$index, scope.row)">查看照片</el-button>
          <el-button
            v-if="scope.row.UserInfo.ValidStatus=='VI'&&calcPermission(permition, 1)"
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
          >通过</el-button>
          <el-button
            v-if="scope.row.UserInfo.ValidStatus=='VI'"
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)&&calcPermission(permition, 2)"
          >不通过</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="auditinfo.UserInfo.UserName"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="30%"
    >
      <el-row>
        <el-col :span="12" :offset="6">
          <el-card :body-style="{ padding: '0px' }">
            <img
              v-if="auditinfo.UserInfo.WorkNumPic!=null"
              :src="auditinfo.UserInfo.WorkNumPic"
              :alt="auditinfo.UserInfo.WorkNumPic"
              class="image"
            >

            <p v-if="auditinfo.UserInfo.WorkNumPic==null">
              <el-tag type="info">暂未照片</el-tag>
            </p>
            <div style="padding: 14px;">
              <span>姓名:{{ auditinfo.UserInfo.UserName }}</span>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <div class="pagination-container">
      <el-pagination
        v-show="checkedDeviceBoxs.TotalRows>0"
        :current-page="listQuery.pageIndex"
        :page-sizes="[10,20,50,100]"
        :page-size="listQuery.pageSize"
        :total="checkedDeviceBoxs.TotalRows"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { qryCourierInfo, courierValid } from '@/api/audit'
import { qryRoleInfo } from '@/api/baseModule'
export default {
  name: 'Audit',
  data() {
    return {
      auditlist: {
        LsList: []
      },
      formInline: {
        user: '',
        region: ''
      },
      dropdownlist: [
        ['validStatus', '审核状态'],
        ['companyName', '公司名称'],
        ['userName', '用户名称'],
        ['workNum', '工号'],
        ['all', '全部']
      ],
      dropdownitem: ['', '请选择查询条件'],
      loading: true,
      dialogVisible: false,
      auditinfo: {
        UserInfo: {
          UserName: null,
          WorkNumPic: ''
        }
      },
      permition: 0,
      checkedDeviceBoxs: { TotalRows: 0 },
      listQuery: {
        pageIndex: 1,
        pageSize: 10,
        identity: undefined,
        type: undefined,
        address: undefined,
        userId: this.$store.getters.roles.UserId
      }
    }
  },
  created() {
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          qryCourierInfo({ pageIndex: 1, pageSize: 10 }).then(Response => {
            this.auditlist = Response
            this.checkedDeviceBoxs.TotalRows = Response.TotalRows
            this.loading = false
          })
        }
      })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            qryCourierInfo({ pageIndex: 1, pageSize: 10 }).then(Response => {
              this.auditlist = Response
              this.checkedDeviceBoxs.TotalRows = Response.TotalRows
              this.loading = false
            })
          }
        })
      })
    }
  },
  methods: {
    getAuditlist({ pageIndex, pageSize, type }) {
      if (type[0] === 'validStatus') {
        qryCourierInfo({
          pageIndex,
          pageSize,
          validStatus: this.formInline.user
        }).then(Response => {
          this.auditlist = Response
          this.checkedDeviceBoxs.TotalRows = Response.TotalRows
          this.loading = false
        })
      } else if (type[0] === 'companyName') {
        qryCourierInfo({
          pageIndex,
          pageSize,
          companyName: this.formInline.user
        }).then(Response => {
          this.auditlist = Response
          this.checkedDeviceBoxs.TotalRows = Response.TotalRows
          this.loading = false
        })
      } else if (type[0] === 'userName') {
        qryCourierInfo({
          pageIndex,
          pageSize,
          userName: this.formInline.user
        }).then(Response => {
          this.auditlist = Response
          this.checkedDeviceBoxs.TotalRows = Response.TotalRows
          this.loading = false
        })
      } else if (type[0] === 'workNum') {
        qryCourierInfo({
          pageIndex,
          pageSize,
          workNum: this.formInline.user
        }).then(Response => {
          this.auditlist = Response
          this.checkedDeviceBoxs.TotalRows = Response.TotalRows
          this.loading = false
        })
      } else {
        qryCourierInfo({
          pageIndex,
          pageSize
        }).then(Response => {
          this.auditlist = Response
          this.checkedDeviceBoxs.TotalRows = Response.TotalRows
          this.loading = false
        })
      }
    },
    handleEdit(index, row) {
      courierValid({
        userId: row.UserInfo.UserId,
        memo: '审核通过',
        status: 'VD'
      }).then(response => {
        this.$message({
          type: 'success',
          message: '审核通过成功'
        })
        this.getAuditlist({
          pageIndex: this.listQuery.pageIndex,
          pageSize: this.listQuery.pageSize
        })
      })
    },
    handleDelete(index, row) {
      this.$prompt('请输入不通过信息', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(({ value }) => {
          courierValid({
            userId: row.UserInfo.UserId,
            memo: value,
            status: 'VF'
          }).then(response => {
            this.$message({
              type: 'success',
              message: '审核不通过成功'
            })
            this.getAuditlist({
              pageIndex: this.listQuery.pageIndex,
              pageSize: this.listQuery.pageSize
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消操作'
          })
        })
    },
    handleSee(index, row) {
      this.auditinfo = row
      this.dialogVisible = true
    },
    ValidStatusFilter(row, column, cellValue, index) {
      if (cellValue === 'VD') {
        return '审核通过'
      }
      if (cellValue === 'VI') {
        return '未审核'
      }
      if (cellValue === 'VF') {
        return '审核失败'
      }
      if (cellValue === null) {
        return '未认证'
      }
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getAuditlist({
        pageIndex: this.listQuery.pageIndex,
        pageSize: this.listQuery.pageSize
      })
    },
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.getAuditlist({
        pageIndex: this.listQuery.pageIndex,
        pageSize: this.listQuery.pageSize
      })
    },
    onSubmit() {
      var type = this.dropdownitem[0]
      if (type.length === 0) {
        this.$message({
          type: 'error',
          message: '请选择查询条件'
        })
      } else if (this.formInline.user.length === 0 && type !== 'all') {
        this.$message({
          type: 'error',
          message: '请输入内容'
        })
      } else {
        this.getAuditlist({
          pageIndex: this.listQuery.pageIndex,
          pageSize: this.listQuery.pageSize,
          type: this.dropdownitem
        })
      }
    },
    editdropdownitem(command) {
      this.dropdownitem = this.dropdownlist[command]
      this.formInline.user = ''
    }
  }
}
</script>
<style>
.auditlist {
  margin: 10px;
}
</style>
